<div class="flex justify-center">
  <p-button
    icon="pi pi-plus"
    [label]="label() | transloco"
    severity="secondary"
    [disabled]="disabled()"
    [attr.data-testid]="testId()"
    (onClick)="add.emit()"
  />
</div>
